import React from "react";
import { Button } from "react-bootstrap";

export interface EmailSuggestionProps {
	emailSuggestion: string;
	name: string;
	setEmailSuggestion: (suggestion: string | null) => void;
	formik: any;
}

const EmailSuggestion: React.FC<EmailSuggestionProps> = ({ emailSuggestion, name, setEmailSuggestion, formik }) => {
	return (
		<span className="email-suggestion" aria-live="polite">
			Did you mean
			<Button
				aria-describedby={"email-suggestion-description"}
				variant={"link"}
				className="btn-link-sm "
				onClick={() => {
					formik.setFieldValue(name, emailSuggestion);
					setEmailSuggestion(null);
				}}
			>
				{emailSuggestion}
			</Button>
			?
			<span id="email-suggestion-description" className="sr-only">
				Set email address field to {emailSuggestion}
			</span>
		</span>
	);
};

export default EmailSuggestion;
